import { Breadcrumbs as BreadcrumbsMui, Link, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';

interface HeaderProps {
  breadcrumbs?: any;
  mainHeader?: string;
  pageTitle?: string;
}
const Breadcrumbs: FC<HeaderProps> = ({breadcrumbs, pageTitle, mainHeader, ...rest }) => {
  return (
    <>
      <BreadcrumbsMui
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Typography
          variant="body1"
          color="textPrimary"
        >
          {mainHeader}
        </Typography>
        {breadcrumbs.map((breadcrumb, index) => {
          return (<Link
            key={index}
            variant="body1"
            color="inherit"
            to={`/app${breadcrumb.path}`}
            component={RouterLink}
          >
            {breadcrumb.name}
          </Link>);
        })}
        <Typography
          variant="body1"
          color="textPrimary"
        >
          {pageTitle}
        </Typography>
      </BreadcrumbsMui>
    </>
  );
};

export default Breadcrumbs;
